import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { AppService } from 'briteatlib';

export const CURRENT_BUSINESS_ID = 'current-business-id';
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  isBrowser: boolean;
  constructor(
    private http: HttpClient, private appService: AppService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private breakpointObserver: BreakpointObserver) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  isDesktop$ = this.breakpointObserver.observe('(min-width: 1024px)').pipe(map(result => result.matches));


  async setActiveBusiness() {
    if (!this.isBrowser) return;
    var business: any;
    var hq: any;
    // A failed domain/business lookup must never block the homepage from
    // rendering: if any request throws we fall through and emit nulls so the
    // default BritEat landing page is shown instead of a blank screen.
    try {
      if (window.location.host !== environment.host) {
        // Resolve HQ domains first so a brand landing page can own the apex
        // domain even if the same domain is still present on an old branch.
        hq = await firstValueFrom(this.http.get<any>('/api/hq/by-domain', { params: { domain: window.location.hostname } }));
        if (!hq)
          business = await firstValueFrom(this.http.get<any>('/api/business/by-domain', { params: { domain: window.location.hostname } }));
      }
      else {
        var businessId = localStorage.getItem(CURRENT_BUSINESS_ID);
        if (businessId)
          business = await firstValueFrom(this.http.get<any>('/api/business/get/' + businessId));
      }
    } catch {
      business = null;
      hq = null;
    }
    this.appService.activeBusiness$.next(business || null);
    this.appService.activeHq$.next(hq || null);
    return business;
  }


}

